module.exports = __webpack_public_path__ + "img/item12.febab233.jpg";